import tempMeeApi from '../../../apis/tempMee';

/**
 * Remove a candidate from shortlist
 *
 * @param {import('../types/ShortlistCandidate.parameters').IShortlistCandidatePayload} payload - Request payload
 * @returns {Promise<void>} No content response
 */
export const removeShortlistCandidate = async ({ candidateId }) => {
  await tempMeeApi.delete(`/recruitment-service/admin/candidates/${candidateId}/shortlist`);
};
